import React, { useState } from 'react';
import { InView } from 'react-intersection-observer';
import { useCurrentWidth } from '@fff-web/fff-ui-shared/hooks';
import classNames from 'classnames';
import CloudinaryImageWrapper from '../../../components/CloudinaryImageWrapper';
import breakpoints from '../../../utils/breakpoints';

import products from './heroProductsData';
import styles from './heroProducts.module.scss';

const HeroProducts = () => {
  const currentWidth = useCurrentWidth();
  const isDesktop = currentWidth >= breakpoints.medium;
  const [showAnimation, setShowAnimation] = useState(true);

  const buildImages = () => products.map((product) => (
    <CloudinaryImageWrapper
      width="auto"
      height={isDesktop ? product.height : product.mobileHeight}
      publicId={product.publicId}
      alt={product.alt}
      key={product.publicId}
    />
  ));
  return (
    <InView onChange={(inView) => setShowAnimation(inView)}>
      <div className={classNames(styles.heroProducts, { [styles.heroProductsAnimated]: showAnimation })}>
        {buildImages()}
      </div>
    </InView>
  );
};

export default HeroProducts;
